import React from 'react';
import { Lock, Clock } from 'lucide-react';
import { SURVEY_CONFIG } from '../config/surveyConfig';

export function ClosedScreen({ status = 'closed' }) {
  const isClosed = status === 'closed';
  const message = isClosed ? SURVEY_CONFIG.CLOSED_MESSAGE : SURVEY_CONFIG.WAITING_MESSAGE;
  const Icon = isClosed ? Lock : Clock;

  return (
    <div className="flex-1 flex items-center justify-center px-4 py-6 pb-32">
      <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 max-w-xl w-full text-center">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="bg-amber-100 rounded-full p-4">
            <Icon className="w-12 h-12 text-amber-600" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-3">
          {message.title}
        </h2>

        {/* Description */}
        <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
          {message.description}
        </p>

        {/* Additional Info */}
        {isClosed && (
          <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-4">
            <p className="text-xs sm:text-sm text-amber-800">
              Agradecemos a todos que participaram! Os resultados serão divulgados em breve.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
